export default "__VITE_PUBLIC_ASSET__eaa30411__"